module.exports = __webpack_public_path__ + "static/bonus-f9152637bad1a716a614f0e0484b9c50.jpg";